import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getspotlightLargeCardsDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
    largecards: [
    // {
    //     fieldName: "Order Sequence",
    //     fieldValue: "field_homecards_sequence",
    //     className: "col-span-6",
    //     type: "text",
    //     name: "field_homecards_sequence",
    //     formType: "input",
    //     label: "Order Sequence",
    //     placeholder: "Enter Order Sequence",
    //     validation: { required: "Order Sequence is required" },
    // },
    {
      fieldName: "Image",
      fieldValue: "field_homecards_image",
      className: "col-span-6",
      type: "image",
      name: "field_homecards_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "field_large_title_html_en",
      className: "col-span-6",
      type: "text",
      name: "field_large_title_html_en",
      formType: "richText",
      label: "Title (EN)",
      placeholder: "Enter the Title (EN)",
      validation: { required: " Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_large_title_html_ms",
        className: "col-span-6",
        type: "text",
        name: "field_large_title_html_ms",
        formType: "richText",
        label: "Title (MS)",
        placeholder: " Enter the Title (MS)",
        // validation: { required: " Title is required" },
      },  {
        fieldName: "Title (ZH)",
        fieldValue: "field_home_large_html_zh",
        className: "col-span-6",
        type: "text",
        name: "field_home_large_html_zh",
        formType: "richText",
        label: "Title (ZH)",
        placeholder: " Enter the Title (ZH)",
        // validation: { required: " Title is required" },
      },
      {
      fieldName: "Button Text (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Button Text (EN)",
      placeholder: " Enter the Button Text (EN)",
      validation: { required: " Button Text (EN) is required" },
    },
    {
        fieldName: "Button Text (MS)",
        fieldValue: "field_homecards_title_ms",
        className: "col-span-6",
        type: "text",
        name: "field_homecards_title_ms",
        formType: "input",
        label: "Button Text (MS)",
        placeholder: " Enter the Button Text (MS)",
        // validation: { required: " Title is required" },
      },  {
        fieldName: "Button Text (ZH)",
        fieldValue: "field_homecards_title_zh",
        className: "col-span-6",
        type: "text",
        name: "field_homecards_title_zh",
        formType: "input",
        label: "Button Text (ZH)",
        placeholder: " Enter the Button Text (ZH)",
        // validation: { required: " Title is required" },
      },
    {
        fieldName: "Description (EN)",
        fieldValue: "field_homecards_desc_en",
        className: "col-span-6",
        type: "text",
        name: "field_homecards_desc_en",
        formType: "richText",
        label: "Description (EN)",
        placeholder: "Enter Description (EN)",
        validation: { required: "Description (EN) is required" },
      },
      {
        fieldName: "Description (MS)",
        fieldValue: "field_homecards_desc_ms",
        className: "col-span-6",
        type: "text",
        name: "field_homecards_desc_ms",
        formType: "richText",
        label: "Description (MS)",
        placeholder: "Enter Description (MS)",
        // validation: { required: "Description (MS) is required" },
      },
      {
        fieldName: "Description (ZH)",
        fieldValue: "field_homecards_desc_zh",
        className: "col-span-6",
        type: "text",
        name: "field_homecards_desc_zh",
        formType: "richText",
        label: "Description (ZH)",
        placeholder: "Enter Description (ZH)",
        // validation: { required: "Description (ZH) is required" },
      },
    {
      fieldName: "Cards url",
      fieldValue: "field_homecards_url_en",
      className: "col-span-6",
      type: "text",
      name: "field_homecards_url_en",
      formType: "input",
      label: "Cards url",
      placeholder: "Enter Cards url",
      validation: { required: "Cards Url is required", validate: (value: string) => {
  const trimmed = value.trim();
  if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
  if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    return "Looks like an external link. Please use an in-app page link, such as /example";
  }
  return true;
}},
    },
    // {
    //   fieldName: "Cards url (MS)",
    //   fieldValue: "field_homecards_url_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_homecards_url_ms",
    //   formType: "input",
    //   label: "Cards url (MS)",
    //   placeholder: "Enter Cards url (MS)",
    //   // validation: { required: "Cards url (MS) is required" },
    // },
    // {
    //   fieldName: "Cards url (ZH)",
    //   fieldValue: "field_homecards_url_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_homecards_url_zh",
    //   formType: "input",
    //   label: "Cards url (ZH)",
    //   placeholder: "Enter Cards url (ZH)",
    //   // validation: { required: "Cards url (ZH) is required" },
    // },
  ],
};
